import { createImg } from "../../DomUtilities/ElementsCreator";
import Item from "../../Models/Item";
import Order from "../../Models/Order";
import ItemCategory from "../../Models/ItemCategory";
import { createItemServiceVariantTiles } from "./ChooseService/VariantCartTile";
import OrderValidator from "./OrderValidator";
import Mediator from "../../Utilities/Mediator";

export default class OrderHandler {
	static readonly order: Order = new Order();
	static currentItems: Array<ItemCategory>;
	static completedSelectedItems: Set<string>;
	static selectedItem: ItemCategory;
	static items: Array<ItemCategory>;
	static cartIconContainer: HTMLDivElement = document.querySelector(".cart-icon");
	static isFastTrack: boolean;
	static isDibsEnabled: boolean;
	static readonly EXPRESS_DELIVERY_ID: string = "60afaed38979fc1b64ccf89a";
	static readonly EXPRESS_DELIVERY_COST: number = document.querySelector(".bill-total .tagcode") ? 65 : 100;

	public static get totalExpressDeliveryCost(): number {
		if (this.hasExpressDelivery) {
			return this.totalItemsCountExceptExpressDelivery * this.EXPRESS_DELIVERY_COST;
		}

		return 0;
	}

	public static get totalItemsCountExceptExpressDelivery(): number {
		return this.order.items.filter(i => i.id != this.EXPRESS_DELIVERY_ID).reduce((temp, item) => temp + item.count, 0);
	}

	public static get hasExpressDelivery(): boolean {
		return this.order.items.some(i => i.id === this.EXPRESS_DELIVERY_ID);
	}

	public static updateExpressDeliveryCount() {
		if (this.hasExpressDelivery) {
			const expressDeliveryItem = this.order.items.find(i => i.id === this.EXPRESS_DELIVERY_ID);
			expressDeliveryItem.count = this.totalItemsCountExceptExpressDelivery;
		}
	}

	public static removeItem(itemId: string) {
		if (this.selectedItem.itemId === itemId) {
			this.selectedItem.services.length = 0;
		}
		this.order.items = this.order.items.filter(item => item.itemId != itemId);
		createItemServiceVariantTiles();
		this.updateCartIconCount();
		Mediator.emit("orderStateChanged");
	}

	public static removeService(itemId: string, serviceId: string) {
		if (this.selectedItem.itemId === itemId) {
			this.selectedItem.services = this.selectedItem.services.filter(s => s.id != serviceId);
		}

		const item = this.order.items.find(i => i.itemId === itemId);
		if (item) {
			item.services = item.services.filter(s => s.id != serviceId);
			if (item.services.length === 0) {
				this.order.items.splice(this.order.items.indexOf(item), 1);
			}
			this.completedSelectedItems.delete(itemId);
		}
		createItemServiceVariantTiles();
		this.updateCartIconCount();
	}

	public static removeVariants(itemId: string, serviceId: string) {
		if (this.selectedItem.itemId === itemId) {
			const serviceIndex = this.selectedItem.services.findIndex(s => s.id === serviceId);
			this.selectedItem.services[serviceIndex].variants.length = 0;
			this.selectedItem.services[serviceIndex].imageSrc = null;
		}

		const item = this.order.items.find(i => i.itemId === itemId);
		if (item) {
			item.services = item.services.filter(s => s.id != serviceId);
			if (item.services.length === 0) {
				this.order.items.splice(this.order.items.indexOf(item), 1);
			}
			this.completedSelectedItems.delete(itemId);
		}
		createItemServiceVariantTiles();
		this.updateCartIconCount();
	}

	public static addSelectedItemToShoppingCart() {
		const validServices = this.selectedItem.services.filter(s => OrderValidator.isValidService(s));

		if (validServices.length > 0) {
			const item = this.order.items.find(i => i.itemId === this.selectedItem.itemId) ?? new Item();

			item.count = 1;
			item.itemTypeId = this.selectedItem.id;
			item.name = this.selectedItem.name;
			item.services = validServices;
			item.itemId = this.selectedItem.itemId;

			let itemIndex = this.order.items.findIndex(i => i.itemId === item.itemId);
			if (itemIndex === -1) {
				this.order.items.push(item);
			} else {
				this.order.items.splice(itemIndex, 1, item);
			}

			this.completedSelectedItems.add(item.itemId);
		}
		createItemServiceVariantTiles();
		this.updateCartIconCount();
	}

	public static updateCartIconCount() {
		this.cartIconContainer.innerHTML = "";
		const cartIcon = createImg("/assets/shopping_cart2.svg", "cart icon");
		this.cartIconContainer.classList.add("cart-icon");
		this.cartIconContainer.appendChild(cartIcon);
		const itemsCountDiv = document.createElement('div');
		this.cartIconContainer.appendChild(itemsCountDiv);
		itemsCountDiv.innerText = `${this.order.items.length}`;

		if (this.order.items.length > 0) {
			window.onbeforeunload = () => "";
		} else {
			Mediator.emit("allItemsDeleted");
			window.onbeforeunload = null;
		}
	}
}
